import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const LINE_HEIGHT_FACTOR = 2

class FamilyHeader extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false,
      buttonText: 'Ver mais',
      buttonTextIsVisible: false
    }
  }

  componentDidMount () {
    this.setbuttonTextVisibility()
  }

  toggleTextBlock = () => {
    const activeState = this.state.isOpen

    const isOpen = !activeState
    const buttonText = activeState ? 'Ver mais' : 'Ocultar'

    this.setState({ isOpen, buttonText })
  }

  setbuttonTextVisibility = () => {
    const textBlock = document.querySelector('.accordion-text-block .text-block')
    const styleList = window.getComputedStyle(textBlock)

    const textBlockLineHeight = parseInt(styleList.getPropertyValue('line-height'), 10)
    const textBlockHeight = parseInt(styleList.getPropertyValue('height'), 10)
    const quotient = textBlockHeight / textBlockLineHeight

    if (quotient > LINE_HEIGHT_FACTOR) {
      this.setState({ buttonTextIsVisible: true })
    } else {
      this.setState({ buttonTextIsVisible: false })
    }
  }

  render () {
    const { name, description } = this.props
    const { buttonText, isOpen, buttonTextIsVisible } = this.state

    const textBlockClass = classNames(
      'text-block',
      {
        'is-open': isOpen
      }
    )

    return (
      <div className="family-header">
        <h1 className="title">{name}</h1>
        <div className="accordion-text-block">
          <div
            className={textBlockClass}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {buttonTextIsVisible &&
            <div className="accordion-text-block-line-wrapper">
              <button
                className="button-toggle-accordion"
                type="button"
                onClick={this.toggleTextBlock}
              >
                <strong>{ buttonText }</strong>
              </button>
            </div>
          }
        </div>
      </div>
    )
  }
}

FamilyHeader.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default FamilyHeader
